__turbopack_context__.v({
  "button": "style-module__kox-LG__button",
  "fixedbutton": "style-module__kox-LG__fixedbutton",
});
